export interface BannerTagType {
  value: string;
  dot: string;
  /** Selo no slider do login (fundo escuro) */
  slider: string;
  /** Selo na prévia do admin */
  preview: string;
}

export const BANNER_TAGS: BannerTagType[] = [
  { value: 'NOVIDADES', dot: 'bg-red-500', slider: 'border-red-500/70 bg-red-500/10 text-red-400', preview: 'bg-red-500/20 text-red-500' },
  { value: 'EM BREVE', dot: 'bg-emerald-500', slider: 'border-emerald-500/70 bg-emerald-500/10 text-emerald-400', preview: 'bg-emerald-500/20 text-emerald-500' },
  { value: 'ATUALIZAÇÃO', dot: 'bg-amber-600', slider: 'border-amber-600/70 bg-amber-600/10 text-amber-500', preview: 'bg-amber-600/20 text-amber-600' },
  { value: 'LANÇAMENTO', dot: 'bg-violet-500', slider: 'border-violet-500/70 bg-violet-500/10 text-violet-400', preview: 'bg-violet-500/20 text-violet-500' },
  { value: 'DESTAQUE', dot: 'bg-sky-500', slider: 'border-sky-500/70 bg-sky-500/10 text-sky-400', preview: 'bg-sky-500/20 text-sky-500' },
];

export const getBannerTag = (tag?: string | null) =>
  BANNER_TAGS.find((t) => t.value === tag?.trim().toUpperCase()) ?? BANNER_TAGS[0];
